import React from "react";
import { SITE, whatsappLink } from "@/lib/site";
import { MessageCircle } from "lucide-react";

export const WhatsAppFloat = () => {
  return (
    <a
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-[60] group"
    >
      <span className="absolute inset-0 rounded-full animate-pulse-glow"></span>
      <span className="relative flex items-center gap-3 bg-[#25D366] text-white pl-4 pr-5 py-3 rounded-full shadow-[0_10px_40px_-10px_rgba(37,211,102,0.6)] hover:scale-[1.03] transition-transform">
        <MessageCircle className="w-5 h-5" strokeWidth={2.5} />
        <span className="hidden sm:inline text-sm font-semibold tracking-wide">Chat on WhatsApp</span>
      </span>
    </a>
  );
};

export default WhatsAppFloat;
